(function() {
	'use strict';

	angular.module('quantixApp').controller(
			'UsageTrackerController', UsageTrackerController);

	UsageTrackerController.$inject = ['$scope','$http','UsageTrackerService','$window','PortfolioTrackerService','baseRequest','$timeout'];

	function UsageTrackerController($scope,$http,UsageTrackerService,$window,PortfolioTrackerService,baseRequest,$timeout) {
		
		var userGrid='';
		var usageTrackerGrid = '';
		$scope.usageTrackerGridData = {
         	dataProvider : [],
			delegate : $scope

		};
		$scope.finalData = {};
		$scope.finData =[];
		$scope.clientNameList = [];
		$scope.clientModel = [];
		$scope.selectedclientNameTemp = [];
		$scope.porttoDate = '';
		$scope.portfromDate = '';
		$scope.fromDate = new Date();
		$scope.toDate = new Date();
		$scope.usageTrackerGrid = '';
		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy',
				'shortDate', 'dd-MMM-yyyy' ];

		$scope.format = $scope.formats[0];
		$scope.requiredFormat = $scope.formats[4];

		$scope.$watch('fromDate', function() {

			if (!$scope.fromDate) {
				return;
			}
			if (!$scope.startMaxDate || $scope.startMaxDate > $scope.fromDate) {
				$scope.endMaxDate = new Date();
			} else {
				$scope.startMaxDate = $scope.fromDate;
			}
			$scope.fromDate = $scope.fromDate;

		});

		$scope.$watch('misReport.toDate', function() {

			if (!$scope.toDate) {
				return;
			}
			if (!$scope.endMaxDate || ($scope.endMaxDate > $scope.fromDate)) {
				// $scope.endMaxDate = $scope.misReport.toDate;
			} else {
				$scope.startMaxDate = $scope.toDate;
			}
			$scope.toDate = $scope.toDate;
		});

		
		$scope.restFilter = function() {

			var d = new Date(); 
			d.setMonth(d.getMonth() - 6);
			$scope.portfromDate = d;
			$scope.porttoDate = new Date();
			$scope.fromDate = d;
			$scope.toDate = new Date();
			$scope.clientModel = [];
			$scope.selectedclientNameTemp = [];
			$scope.getUsageTrackerDetails();
		}

		// get Client name List for client name filter
		$scope.getClientNameList = function() {

			PortfolioTrackerService.getClientList().then(function(data) {
				$scope.clientNameList = data;
			}, function(errordata) {
				
			});

		}
		
		$scope.checkErrForSme = function(fromDate, toDate) {
			$scope.errMessage = '';
			$scope.fromDateTrue = false;
			$scope.toDateTrue = false;

			var curDate = new Date();

			if (fromDate != '' && toDate != '') {
				if (new Date(fromDate) > new Date(toDate)) {
					$scope.toDateTrue = false;
					alert("todate should be greater than fromDate.");
					return false;
				} else {
					$scope.toDateTrue = true;
				}
				if (new Date(fromDate) < curDate) {
					$scope.fromDateTrue = true;
				} else {
					$scope.fromDateTrue = false;
					$scope.errMessage = 'fromDate should not be before today.';
					alert("fromDate should not be before today.");
					return false;
				}
			} else {
				$scope.fromDateTrue = true;
				$scope.toDateTrue = true;
			}
		};

		$scope.popup3 = {
			opened : false
		};
		$scope.popup4 = {
			opened : false
		};
		$scope.open3 = function($event) {
			$scope.popup3.opened = true;
		};
		$scope.open4 = function($event) {
			$scope.popup4.opened = true;
		};
				
		
		$scope.getUsageTrackerDetails = function() {
			
			$scope.checkErrForSme($scope.portfromDate, $scope.porttoDate);
			if ($scope.fromDateTrue == true && $scope.toDateTrue == true) {
				$scope.toDateData = $scope.porttoDate;
				$scope.fromDateData = $scope.portfromDate;
			} else {
				$scope.toDateData = '';
				$scope.fromDateData = '';
			}

			if ($scope.fromDateData == undefined) {
				$scope.fromDateData = '';
			}

			if ($scope.toDateData == undefined) {
				$scope.toDateData = '';

			}

			// client name

			if ($scope.clientModel != undefined) {
				$scope.selectedclientNameTemp = $scope.clientModel.map(function(
						element) {
					return "<" + String(element.labelName) + "<"
				})
			}

			var searchText = '';
			searchText = "{'fromDate' : '" + $scope.fromDateData
					+ "', 'toDate' : '" + $scope.toDateData
					+ "','clientName':'" + $scope.selectedclientNameTemp + "'}";
			searchText = searchText.replace(/\'/g, "\"");
			searchText = searchText.replace(/\</g, "\'");
			$scope.userTrackerExDataTemp=searchText;
			var fd = new FormData();
			fd.append('searchText', $scope.userTrackerExDataTemp);
			fd.append('exportFlag', 'false');
			 UsageTrackerService.getUsageTrackerData(fd).then(
					function(result) {

						$scope.finalData =result;
						$scope.finData=result.usageTrackerDto;
						$scope.usageTrackerGridData = {
							dataProvider : result,
							delegate : $scope
						};
						
							$timeout(function() {								
								$scope.usageTrackerGrid.setPreservePager(true);
								$scope.usageTrackerGrid.setDataProvider(result.usageTrackerDto);
								if (result.usageTrackerDto.length > 0) {
								$scope.usageTrackerGrid.setTotalRecords(result.totalCount);
								}else{
									$scope.usageTrackerGrid.setTotalRecords(0);
								}
							
								
								$scope.usageTrackerGrid.validateNow();
								$scope.usageTrackerGrid.rebuild();
							}, 100);
					});
			
		}
		$scope.filterPageSortChangeHandler = function(evt1){
			

			$scope.usageTrackerGrid = evt1.target;
			var filter = {
				pageNumber : evt1.filter.pageIndex + 1 || 1,
				pageSize : evt1.filter.pageSize || 15,
				searchText : $scope.userTrackerExDataTemp,	
				sortColumn :(evt1.filter.sorts != undefined && evt1.filter.sorts.length>0)?evt1.filter.sorts[0].sortColumn:null ,
				sort : 	 (evt1.filter.sorts!=undefined && evt1.filter.sorts.length>0)?((evt1.filter.sorts[0].isAscending)?"asc":"desc"):"asc",
						
			};

			baseRequest('api/usageTracker/getFilterServerSidePagination', filter)
					.then(
							function(data) {
								$scope.usageTrackerGrid.setPreservePager(true);
								$scope.usageTrackerGrid
										.setDataProvider(data.data.usageTrackerDto);
								
								if (data.data.usageTrackerDto.length > 0) {
									$scope.usageTrackerGrid.setTotalRecords(data.data.totalCount);
									
								} else {
									$scope.usageTrackerGrid.setTotalRecords(0);
								}
								$scope.usageTrackerGrid.validateNow();

							});

		
		}

	 

		$scope.exportExcelUsageTracker = function() {

			$http({
				url : 'api/UsageTracker/UsageTrackerExcelExportData',
				method : 'POST',
				data : $scope.userTrackerExDataTemp,
				responseType : 'arraybuffer'
			})
					.success(

							function(response) {

								var isIE = false || !!document.documentMode;
								$scope.response = response;
								var blob = new Blob(
										[ response ],
										{
											type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
										});
								if (isIE) {

									window.navigator.msSaveOrOpenBlob(blob,
											'UsageTracker Report.xlsx');
								} else {

									var anchor = angular.element('<a/>');
									var blob = new Blob([ response ], {
										type : 'application/vnd.ms-excel'
									})
									var objectUrl = (window.URL || window.webkitURL)
											.createObjectURL(blob);
									anchor.css({
										display : 'none'
									});
									// Make sure it's not visible
									angular.element(document.body).append(
											anchor); // Attach to document
									anchor.attr({
										href : objectUrl,
										target : '_self',

										download : 'UsageTracker Report.xlsx'
									})[0].click();

									anchor.remove();

								}

							})

		}

		$scope.usageTrackerGridCompletion = function(event) {
		 
			$scope.usageTrackerGrid = event.target;
		 	$scope.usageTrackerGrid.setPreservePager(true);
			$scope.usageTrackerGrid.setDataProvider($scope.finalData.usageTrackerDto);
                 if($scope.finData.length>0){
                	 $scope.usageTrackerGrid.setTotalRecords($scope.finalData.totalCount);}else{
                		 $scope.usageTrackerGrid.setTotalRecords(0);
                 }
                 $scope.usageTrackerGrid.validateNow(); 
          
		};
		
		$scope.getClientNameList();		
		$scope.restFilter();
	}

})();
